export const Platforms = Object.freeze({
  TWITTER: "x",
  LINKEDIN: "linkedin",
  INSTAGRAM: "instagram",
  TIKTOK: "tiktok",
  BLUESKY: "bluesky",
});

export const PLATFORM_TYPES = Object.values(Platforms);
